import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/operators?accountID=${accountID}`
      }))
  );
}

async function getById(operatorID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/operators/${operatorID}`
      }))
  );
}

async function create(operator) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/operators',
        body: JSON.stringify(operator)
      }))
  );
}

async function createMultiple(operatorList) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/operators/bulk',
        body: JSON.stringify(operatorList)
      }))
  );
}

async function update(operator) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/operators/${operator.operatorID}`,
        body: JSON.stringify(operator)
      }))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(operatorID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/operators/${operatorID}`
      }))
  );
}

const operatorService = {
  getAll,
  getById,
  create,
  createMultiple,
  update,
  delete: Delete
};

export default operatorService;
